module.exports = __webpack_public_path__ + "static/img/index_video2.1179d12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_video2.jpg
// module id = jWXK
// module chunks = 1